import { FaWifi, FaHeadset, FaDollarSign, FaTv, FaSignal, FaInfinity } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaWifi />, // Wifi icon
    title: 'Internet dove vuoi',
    description: 'Prova la velocità di internet in tecnologia FWA che porta la banda larga a casa tua con la sola istallazione di una piccola antenna.',
  },
  {
    id: 2,
    icon: <FaHeadset />, // Headset icon
    title: 'Assistenza clienti 24/7',
    description: 'Il nostro team di supporto è sempre disponibile per aiutarti con qualsiasi problema relativo al servizio offerto.',
  },
  {
    id: 3,
    icon: <FaDollarSign />, // Dollar Sign icon
    title: '3 pacchetti convenienti',
    description: 'BLU_SMALL 30Mps down - 2Mps up * BLU_MEDIUM 50Mps down - 10Mps up * BLU_PREMIUM 100Mps down - 10Mps up',
  },
  {
    id: 4,
    icon: <FaTv />, // TV icon
    title: 'Connessioni via cavo FTTC/FTTH',
    description: 'FTTC: 200 Mbps download / 20 Mbps upload * FTTH: fino a 2500 Mbps download / 500 Mbps upload',
  },
  {
    id: 5,
    icon: <FaSignal />, // Signal icon
    title: 'BluCall Mobile Multibrand',
    description: 'Sevizi voce e dati con primari operatori del settore e portabilità del vecchio numero.',
  },
  {
    id: 6,
    icon: <FaInfinity />, // Infinity icon
    title: 'Sicurezza informatica',
    description: 'Protezione dei dati e monitoraggio 24/7 del vostro PC.',
  },
];

export default features;